import { observer, useLocalObservable } from 'mobx-react'
import IconCell from './IconCell/IconCell'
import Notify from '../../../../../Notify'
import useOutsideClick from '../../../../../../hooks/useOutsideClick'
import React, { useEffect, useRef, useState } from 'react'
import { useAPI } from '../../../../../../hooks/useAPI'
import styled from 'styled-components'

export const IconCellWithAttention =
  observer(({ onClick, attentionText, iconType, attentionDirection, close }) => {

    const myRef = useRef()


    useOutsideClick(myRef, () => {
      close('')
    })
    return <Cell>
      <Notify notifyVisibility={attentionText}
              notifyInner={attentionText}
              reff={myRef}
              horizontalDirection={attentionDirection}
              size={'medium'}
              customStyles={{ paddingTop: '20px', paddingBottom: '20p', bottom: 'unset'}}
              verticalDirection={'top'}

      >
        <IconCell onClick={async _ => await onClick()} iconName={iconType} />
      </Notify>
    </Cell>
  })

const Cell = styled.div`
  overflow: inherit;
  position: relative;

`

export const IconCellWithAttentionHOC = observer(({ req }) => {
  const { APIRequest, loading } = useAPI()
  const store = useLocalObservable(() => ({
    response: {},
    setResponse: value => store.response = value,
    attention: '',
    setAttention: value => store.attention = value
  }))

  const ERROR_TEXT = `Ой! Что-то пошло не так. Повторите попытку позже.`

  const clickHandler = async () => {
    try {
      await APIRequest(req).then(res => {
        switch (res.message) {
          case 'ok':
            store.setAttention(<>Документ будет отправлен на<Email>{res.body?.data?.email}</Email>Проверьте вашу почту.</>)
            break
          case 'empty':
            store.setAttention('Список результатов пуст')
            break
          case 'not found':
            store.setAttention('Email не указан')
            break
          default:
            store.setAttention(ERROR_TEXT)
        }
      })

    } catch (e) {
      store.setAttention(ERROR_TEXT)
    }

  }

  return <IconCellWithAttention close={store.setAttention} attentionDirection={'left'} attentionText={store.attention}
                                onClick={clickHandler} />
})

const Email = styled.span`
  color: #009FF5
`